export const MONITORS_FILTER = `filter tag = 'httpMonitor'
| group Count = count(),
        Label       = any(label),
        2xx         = count(status >= 200 && status <= 299),
        3xx         = count(status >= 300 && status <= 399),
        4xx         = count(status >= 400 && status <= 499),
        5xx         = count(status >= 500 && status <= 599),
        Timeout     = count(errorType = 'timeout'),
        Size        = mean(responseSize),
        AverageTime = mean(time),
        MaxTime     = max(time)
        by url`;
